import { Card, CardContent, LinearProgress, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useCreateListDataMutation } from '../../../api/apiSlice';
import FormikButton from '../../../components/formik/FormikButton';
import FormikInput from '../../../components/formik/FormikInput';
import FormikSelect from '../../../components/formik/FormikSelect';
import ExternalScreen from '../../../components/fragments/ExternalScreen';
import Form from '../../../components/utilities/Form';
import { devotionTypeInputs } from '../../../enums';
import errorSnackbar from '../../../utils/errorSnackbar';

const validator = Yup.object().shape({
    title: Yup.string().min(5).required('Title is required'),
    body: Yup.string().min(10).required('Body is required'),
    type: Yup.string().required('Type is required'),
    audio: Yup.string().required('Audio is required'),
});

export default function ScreenCreatedevotion() {
    const [file, setFile] = React.useState(null);
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const state = useSelector((st) => st);

    const { user } = state.auth;

    const [createDevotion, { isLoading }] = useCreateListDataMutation();

    return (
        <ExternalScreen title="Create Devotion">
            <Form
                onSubmit={async (values) => {
                    if (!file) return;

                    const formData = new FormData();
                    formData.append('audio', file);
                    formData.append('title', values.title);
                    formData.append('body', values.body);
                    formData.append('type', values.type);
                    formData.append(
                        'writer',
                        `${user.firstName} ${user.lastName}`
                    );

                    const { error, data } = await createDevotion({
                        list: `/op/devotions`,
                        body: formData,
                    });

                    errorSnackbar(error, enqueueSnackbar);

                    if (data) {
                        enqueueSnackbar('Successfully created devotion');
                        navigate(-1);
                    }
                }}
                validationSchema={validator}
                initialValues={{ title: '', body: '', type: '', audio: '' }}
            >
                <FormikInput name="title" label="Title" />
                <FormikInput
                    name="body"
                    label="Devotion Description"
                    multiline
                    rows={4}
                />
                <FormikSelect
                    name="type"
                    label="Devotion Type"
                    data={devotionTypeInputs}
                />
                <Card
                    sx={!isLoading && { background: 'none', boxShadow: 'none' }}
                >
                    <CardContent sx={!isLoading && { p: 0 }}>
                        <FormikInput
                            type="file"
                            name="audio"
                            label="Audio File"
                            onSelectFiles={([f]) => setFile(f)}
                            inputProps={{ accept: 'audio/*' }}
                        />
                        {isLoading && (
                            <>
                                <LinearProgress sx={{ m: 1 }} />
                                <Typography sx={{ mx: 1 }}>
                                    Uploading Image
                                </Typography>
                            </>
                        )}
                    </CardContent>
                </Card>
                <div className="d-flex justify-content-end w-100">
                    <FormikButton loading={isLoading} variant="contained">
                        Create
                    </FormikButton>
                </div>
            </Form>
        </ExternalScreen>
    );
}
